export default __webpack_public_path__ + "static/media/excel_light.30bce8d5.svg";